module.exports = __webpack_public_path__ + "img/qilin-f-stage1-sulking.bda1b688.png";